import { z } from 'zod';
import { localeSchema } from './common';

export const tagStatusSchema = z.enum(['pending', 'approved', 'rejected']);
export type TagStatus = z.infer<typeof tagStatusSchema>;

export const createTagSchema = z.object({
  name: z.string().min(1).max(60),
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/).optional(),
  icon: z.string().max(40).optional(),
  translations: z.record(localeSchema, z.string().min(1).max(60)).optional(),
});
export type CreateTagInput = z.infer<typeof createTagSchema>;

export const updateTagSchema = createTagSchema.partial();
export type UpdateTagInput = z.infer<typeof updateTagSchema>;

export const approveTagSchema = z.object({
  name: z.string().min(1).max(60),
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/).optional(),
  icon: z.string().max(40).optional(),
  translations: z.record(localeSchema, z.string().min(1).max(60)).optional(),
});
export type ApproveTagInput = z.infer<typeof approveTagSchema>;

export const rejectTagSchema = z.object({
  reason: z.string().max(500).optional(),
});
export type RejectTagInput = z.infer<typeof rejectTagSchema>;

export const tagSearchSchema = z.object({
  q: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(50).default(20),
  status: tagStatusSchema.optional(),
});
export type TagSearchInput = z.infer<typeof tagSearchSchema>;

export const similarTagsQuerySchema = z.object({
  q: z.string().min(1).max(60),
  limit: z.coerce.number().int().min(1).max(20).default(5),
});
export type SimilarTagsQuery = z.infer<typeof similarTagsQuerySchema>;

export const setOfficialSchema = z.object({
  isOfficial: z.boolean(),
});
export type SetOfficialInput = z.infer<typeof setOfficialSchema>;
